<app-loader *ngIf="loginCarg"></app-loader>
<div 
  class="modal-content2" 
  [ngStyle]="{'padding': !isInsideModal() ? '0px' : '24px 24px 32px 24px'}"
  >
  <div 
  class="modal-header default-header" 
  *ngIf="isInsideModal()"
  >
    <div class ="flex-title">
      <fa-icon [icon]="faAngleLeft" (click) = "returnToFirstMessage()"></fa-icon>
      <h5 class="modal-title">Agregar dirección</h5>
    </div>
    <button class="close" data-dismiss="modal" aria-label="Close"
      (click)="onNo()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>

  <!--- List of user addresses --->
  <div class = "modal-header" *ngIf="!isInsideModal() && !showAddressForm">
    <h5
    class = "modal-title"
    [style.margin] = "'0px'"
    [style.padding-bottom] = "'24px'"
    >
    Tus direcciones
    </h5>
  </div>
  <div class="modal-body"
    [style.padding] = "'24px'"
    [style.border-radius] = "'8px'"
    *ngIf="!isInsideModal() && !showAddressForm">
      <h4
      class = "list-addresses-title"
      *ngIf="addressOptions.length == 0">
        Aún no has registrado tus direcciones
      </h4>
      <p
      class = "list-addresses-advice" *ngIf="addressOptions.length == 0">
        ¡Agrega tu dirección de entrega y ahorra tiempo en tu próximo pedido!
      </p>
      <p
      class = "list-addresses-advice" *ngIf="addressOptions.length > 0">
        ¡Agiliza tu próximo pedido agregando la información de dónde esperas recibir tus productos!
      </p>
      <div class = "list-address" *ngIf="addressOptions.length > 0">
        <div class = "address-container" *ngFor="let address of addressOptions">
          <div class = "addres-container-header">
            <h4>{{ address.name }}</h4>
            <div>
              <fa-icon [icon]="faEllipsisVertical" (click)="toggleDropdown(address)"></fa-icon>
              <div class = "address-dropdown" *ngIf="address.showDropdown">
                <div (click)="editAddress(address)">
                  <span>Editar</span>
                </div>
                <div (click) = "deleteAddress(address)">
                  <span>Eliminar</span>
                </div>
              </div>
            </div>
          </div>
          <span> {{ address.address }}. {{ address.city }}, {{ address.department }}.</span>
        </div>
      </div>
      <button type="submit"
      class="buy-button"
      (click)="toggleAddressForm()"
      [style.width] = "!isInsideModal() ? '164px' : '100%'"
      [style.margin] = "!isInsideModal() ? '0px' : 'auto'"
      [disabled] = "addressOptions.length >= 3"
      >{{ 'modal.add' | optimizedI18n }}</button>
  </div>  

  <!--- 'Add address' Form --->
  <div
  class = "modal-header"
  *ngIf="!isInsideModal() && showAddressForm"
  [style.padding-bottom] = "'24px'"
  [style.justify-content]="'start'"
  [style.gap]="'8px'"
  >
    <fa-icon
    [icon]="faAngleLeft"
    (click) = "disableEdition()">
    </fa-icon>
    <h5
    class = "modal-title"
    [style.margin] = "'0px'"
    *ngIf="!isEdition"
    >
    Nueva dirección
    </h5>
    <h5
    class = "modal-title"
    [style.margin] = "'0px'"
    *ngIf="isEdition"
    >
    Editar dirección
    </h5>
  </div>
  <div
  class="modal-body default-modal"
  [ngClass] = "{'borders-and-padding': !isInsideModal()}"
  *ngIf="showAddressForm">
    <form [formGroup]="addAddressFormGroup">
      <div class="form-group">
        <app-input-text 
          type="text"
          label="Nombre personalizado"
          placeholder="Escribe aquí"
          frmControl="name"
          class_label="white"
          [formParent]="addAddressFormGroup"
          [maxDigits]="255"></app-input-text>
      </div>

      <div class="form-group">
        <app-input-select
          label="Departamento"
          isLabelTop="true"
          [options]="auth.departaments_colombia"
          placeholder="Seleccione una opción"
          frmControl="department"
          [formParent]="addAddressFormGroup"
          (change)="onDepartamentoChange()"
        ></app-input-select>
      </div>

      <div class="form-group">
        <app-input-select
          label="Ciudad"
          isLabelTop="true"
          [options]="listCities"
          placeholder="Seleccione una opción"
          frmControl="city"
          [formParent]="addAddressFormGroup"
          #citySelect
        ></app-input-select>
        <label class = "city-advice" *ngIf="addAddressFormGroup.get('department').value == ''">Por favor selecciona un departamento para desplegar esta información.</label>
      </div>

      <div class="form-group">
        <app-input-text type="text" label="Dirección"
          placeholder="Ej: Cra 1 # 2-3" frmControl="address"
          class_label="white" [formParent]="addAddressFormGroup"
          [maxDigits]="255"></app-input-text>
      </div>
      
      <button type="submit" class="btn btn-primary btn-block"
        (click)="registerAddress()"
        [style.width] = "!isInsideModal() ? '164px' : '100%'"
        [style.margin] = "!isInsideModal() ? '0px' : 'auto'"
        [disabled]="!addAddressFormGroup.valid || (isEdition && addAddressFormGroup.pristine) || (isEdition && compareFormGroups())">Guardar dirección</button>
    </form>
  </div>
</div>
